module.exports = "<div class=\"calendar\">\n  <my-date-range-picker name=\"mydaterange\" \n    [options]=\"myDateRangePickerOptions\"\n    [(ngModel)]=\"model\"\n    (dateRangeChanged)=\"onDateRangeChanged($event)\">\n  </my-date-range-picker>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/custom-datepicker/custom-datepicker.component.html
// module id = ./src/app/common/custom-datepicker/custom-datepicker.component.html
// module chunks = main